import { createAction } from 'redux-actions';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { reduxKey } from '../../constants';
import { PersonalInformationModal } from './types';

export const setPersonalInformationWidgetPronoun = createAction(
  `${reduxKey}.SET_PERSONAL_INFORMATION_WIDGET_PRONOUN`,
  (pronoun: 'm' | 'f' | 'o') => ({ pronoun })
);

export const setPersonalInformationWidgetShowPronoun = createAction(
  `${reduxKey}.SET_PERSONAL_INFORMATION_WIDGET_SHOW_PRONOUN`,
  (showPronoun: boolean) => ({ showPronoun })
);

export const setPersonalInformationWidgetCountryId = createAction(
  `${reduxKey}.SET_PERSONAL_INFORMATION_WIDGET_COUNTRY_ID`,
  (countryId: number) => ({ countryId })
);

export const setPersonalInformationWidgetBirthday = createAction(
  `${reduxKey}.SET_PERSONAL_INFORMATION_WIDGET_BIRTHDAY`,
  (birthday: string) => ({ birthday })
);

export const setPersonalInformationWidgetBirthdayDisplay = createAction(
  `${reduxKey}.SET_PERSONAL_INFORMATION_WIDGET_BIRTHDAY_DISPLAY`,
  (birthdayDisplay: 'none' | 'month_and_day' | 'full') => ({
    birthdayDisplay,
  })
);

export const setPersonalInformationWidgetMeasurements = createAction(
  `${reduxKey}.SET_PERSONAL_INFORMATION_WIDGET_MEASUREMENTS`,
  (measurements: 'metric' | 'imperial') => ({ measurements })
);

export const savePersonalInformation = createAction(
  `${reduxKey}.SAVE_PERSONAL_INFORMATION`,
  () => ({})
);

export const savePersonalInformationSuccess = createAction(
  `${reduxKey}.SAVE_PERSONAL_INFORMATION_SUCCESS`,
  () => ({})
);

export const savePersonalInformationFailure = createAction(
  `${reduxKey}.SAVE_PERSONAL_INFORMATION_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);

export const pushChangeDateOfBirthModal = () =>
  pushModal(PersonalInformationModal.ChangeDateOfBirth, {
    wrapInModal: false,
  });

export const submitChangeDateOfBirthModal = createAction(
  `${reduxKey}.SUBMIT_CHANGE_DATE_OF_BIRTH_MODAL`,
  (month: number, day: number, year: number) => ({ month, day, year })
);

export const pushWhyDisplayDateOfBirthModal = () =>
  pushModal(PersonalInformationModal.WhyDisplayDateOfBirth, {
    wrapInModal: false,
  });
